/* @flow */

import { compose } from 'ramda';
import * as React from 'react';

import SignupActivationSection from './activation/SignupActivationSection';
import SignupEmailSection from './email/SignupEmailSection';
import SignupPasswordSection from './password/SignupPasswordSection';

type Props = {
  showEmailForm: boolean,
  showPasswordForm: boolean,
  isPasswordSet: boolean,
  handleActivationSubmit: (Object) => Promise<any>,
  handleEmailSubmit: (Object) => Promise<any>,
  handlePasswordSubmit: (Object) => Promise<any>,
  handlePasswordBack: () => void,
};

const SignupAuthenticationWizardDumb = ({
  showEmailForm,
  showPasswordForm,
  isPasswordSet,
  handleActivationSubmit,
  handleEmailSubmit,
  handlePasswordSubmit,
  handlePasswordBack,
}: Props): React.Node => {
  if (showEmailForm) {
    return <SignupEmailSection handleSubmit={handleEmailSubmit} />;
  } else if (showPasswordForm) {
    return (
      <SignupPasswordSection
        isPasswordSet={isPasswordSet}
        handleSubmit={handlePasswordSubmit}
        handleBack={handlePasswordBack}
      />
    );
  }

  return <SignupActivationSection handleSubmit={handleActivationSubmit} />;
};

export default compose(React.memo)(SignupAuthenticationWizardDumb);
